module.exports = __webpack_public_path__ + "img/wifi-label.892449d9.svg";